import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

export const queryKeys = {
  students: (filters) => ['students', filters],
  gradeCatalog: (schoolCode) => ['gradeCatalog', schoolCode || ''],
  classes: () => ['classes'],
  marksBatchCounts: (batchKeys) => ['marks', 'batchStudentCounts', batchKeys || ''],
  notifications: (opts) => ['notifications', opts],
  notificationUnread: () => ['notifications', 'unread-count'],
  student360: (id, schoolCode) => ['student360', id, schoolCode || ''],
};
